<template>
  <div class="plan-appliance" >

    <div class="plan-appliance-image">
      <img :src="$images.image(appliance.modelNumber, appliance.accessory)" :alt="appliance.modelNumber"/>
    </div>
    <div class="plan-appliance-description">
      <div class="model-number">{{applianceName}}</div>
      <div class="serial-number">{{appliance.serialNumber ?? '-'}}</div>
      <div class="lab-name">Lab. {{appliance.labName ?? '-'}}</div>
    </div>


  </div>
</template>

<script>
export default {
  components: {
  },
  setup() {
  },
  props: {
    appliance: Object,
  },
  data() {
    return {
    };
  },
  computed: {
    applianceName() {
        return this.appliance.name ?? this.appliance.modelNumber;
      },
  },
  watch: {
  },
  created() {
  },
  mounted() {
  },
  methods: {
  },
}
</script>

<style scoped>

.plan-appliance {
  display: flex;
  align-items: center;
  gap: 10px;
}

.plan-appliance .plan-appliance-image {
  width: 80px;
  height: 120px;
}

.plan-appliance .plan-appliance-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.plan-appliance .plan-appliance-description {
  display: flex;
  flex-direction: column;
  /* gap: 5px; */
}

.plan-appliance .plan-appliance-description .model-number {
  font-weight: 600;
  font-size: 30px;
  color: #002445;
}

.plan-appliance .plan-appliance-description .serial-number {
  font-weight: 600;
  font-size: 16px;
  color: #9D9D9C;
}
.plan-appliance .plan-appliance-description .lab-name {
  font-weight: 600;
  font-size: 16px;
  color: #9D9D9C;
}


</style>